import App from 'app/app.js';
import 'app/store/ContentStore.js';
import 'app/service/StorageService.js';
import { DEFAULT_HTTP_TIMEOUT } from '@app/interceptor/interceptor-logic';

function HttpTimeoutInterceptor(StorageService, $injector) {
  return {
    request: function (config) {
      var cs = $injector.get('ContentStore');

      config.timeout = cs.getConfig().httpRequestTimeout || DEFAULT_HTTP_TIMEOUT;
      return config;
    },
    response: function (response) {
      return response;
    }
  };
}

App.factory('HttpTimeoutInterceptor', ['StorageService', '$injector', HttpTimeoutInterceptor]);
App.config([
  '$httpProvider',
  function ($httpProvider) {
    $httpProvider.interceptors.push('HttpTimeoutInterceptor');
  }
]);
